import React from 'react';
function RedStar() {
    return (
        <span class="red-star">*</span>
    )
}

export default RedStar